/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmConversationsDeleteItem } from "../../funcs/llmConversationsDeleteItem.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ConversationsItemsDeleteRequest$inboundSchema,
};

export const tool$llmConversationsDeleteItem: ToolDefinition<typeof args> = {
  name: "llm-conversations-delete-item",
  description: `Delete a conversation item

Delete an item from a conversation with the given ID.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmConversationsDeleteItem(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
